export default __webpack_public_path__ + "static/media/100_51325.bb081c61.jpg";